export const routes = {
    homeRoute: '/',
    helpersRoute: '/helpers',
    registerRoute: '/register',
    thankYouRoute: '/thank-you',
    privacyPolicyRoute: '/privacy-policy',
    dailyPoll: '/daily-poll',
    user: '/user',
    userUnsubscribe: '/user/unsubscribe',
    dailyPollSuccessful: '/daily-poll-already-completed',
};
